const riot = require('riot');

riot.tag2('module-thanks-vpoint', '<div class="bg-grad_light_blue w-full h180 pt24"> <div class="text-center ts-hl text-white">ありがとうございました</div> </div> <div class="px24 mtn105"> <div class="w-full p20 rounded-8 elevation-default-mid text-center bg-white mb24"> <div class="f fh mb16"><img class="block s85 object-fit-contain" src="/images/vpoint/logo.svg"></div> <div class="ts-hs text-gray_80 mb4">Vポイント</div> <div class="f fc fb"> <div class="fs40 text-gray_80 mr8">{opts.event.amount.toLocaleString()}</div> <div class="ts-hs text-gray_60">ポイント</div> </div> </div> <div class="border-bottom border-bottom pb24 mb24"> <div class="ts-ps text-gray_80 mb24">下に記載しているURLからVポイントギフトコードをお受け取りください。</div> <div class="ts-ps text-gray_80">このページは {dayjs(opts.event.expires_at).format(\'YYYY年M月D日 HH時mm分\')} 以降は閲覧できなくなります。</div> </div> <div class="mb24"> <div class="text-gray_80 ts-pxs" data-is="atom-anchorify" text="{description}"></div> </div> <div class="mb24"> <div class="text-gray_60 ts-pxs" data-is="atom-anchorify" text="{message}"></div> </div> </div>', '', '', function(opts) {
    const event = this.opts.event;

    var description = `この度は、${event.campaign_display_name}にご応募いただき、誠にありがとうございます。
      ${event.campaign_display_company_name}　${event.campaign_display_name}の事務局でございます。
      以下の通り、Vポイントギフトコードをお送りいたします。

      ■Vポイントギフトコード情報
      ギフトコード : ${event.vpoint_distribution.gift_code}
      ポイント数 : ${event.amount.toLocaleString()}ポイント

      以下よりお受け取りをお願い致します。
      https://get.tsite.jp/?code=${event.vpoint_distribution.gift_code}

      ■ Vポイントの獲得期限について
      Vポイントの獲得期限は、ギフトコード受取日から90日後の23:59:59 までです。
      ※獲得期限を過ぎた場合、Vポイントを獲得することはできません。

      ■ Vポイントの有効期限について
      本キャンペーンで獲得できるVポイントは、ギフトコード受取日を起算日として180日後に有効期限が設定されたポイントとなります。

      ■ Vポイントギフトコードについて
      Vポイントギフトコードを第三者へ譲渡、売買等をすることはできません。
      Vポイントギフトコードに関するサービスの一部または全部は、予告なく中断・停止または終了する場合があります。
      Vポイントギフトコードの盗難、紛失などで第三者がギフトコードを使用してしまった場合でも、CCCMKホールディングス株式会社はその責を負いませんので、保管には十分にご注意ください。`;

    this.description = description.replace(/^ +/gm, "");

    this.message = ''
});